import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=0ae10b29&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=0ae10b29&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae10b29",
  null
  
)

export default component.exports